import { SearchType } from './defs';

/**
 * Al buscar, el payload usa `searchType` (A/C) y no incluye `searchByUser`.
 * Al restaurar desde sesión o URL, hay que volver a derivar el checkbox.
 */
export function mergeSearchByUserFromStoredSearchType<T extends Record<string, unknown>>(
  raw: T | null | undefined
): T {
  if (raw == null) {
    return {} as T;
  }
  const o = { ...raw } as Record<string, unknown>;
  if (o['searchType'] != null) {
    o['searchByUser'] = o['searchType'] === SearchType.User;
    delete o['searchType'];
  }
  return o as T;
}
